export enum DomesticTravelCoverTypeCode {
  NotCovered = 'NOTCOVERED',
  Covered = 'COVERED',
  CoveredOutside100Miles = 'COVEREDOUTSIDE100MILES',
  CoveredOutsideProvince = 'COVEREDOUTSIDEPROVINCE',
}
